import { ArrowRight } from "@phosphor-icons/react/dist/ssr";

import { Button } from "@/src/components/ui/Button";
import { Tag } from "@/src/components/ui/Tag";
import { Text } from "@/src/components/ui/Typography";

import type { ExpertiseItem } from "./data";

interface ExpertiseDetailProps {
  item: ExpertiseItem;
}

export function ExpertiseDetail({ item }: ExpertiseDetailProps) {
  return (
    <div className="flex h-full flex-col items-start">
      <div className="flex flex-wrap gap-3">
        {item.tags.map((tag) => (
          <Tag key={tag}>{tag}</Tag>
        ))}
      </div>

      <Text size="bodySM" className="mt-6 max-w-125 text-neutral-600">
        {item.description}
      </Text>

      <Button
        href={item.href}
        variant="link"
        className="mt-auto pl-0"
      >
        Learn More
      </Button>
    </div>
  );
}
